export const getWebHeaders = (consumerVersion: string) => ({
    clientFeature: 'widget-zones',
    clientPage: window.location.pathname.includes('event') ? 'event-page' : 'home',
    clientVersion: consumerVersion,
    widgetName: 'SportSliderWidget',
    widgetVersion: APP_VERSION
});
